import { render } from "./DanmarksKortMap.vue?vue&type=template&id=5727f90e"
import script from "./DanmarksKortMap.vue?vue&type=script&lang=js"
export * from "./DanmarksKortMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__